import { ReactNode, createContext, useContext } from 'react'

interface CreatorTokenContextType {
  token: string
}

const CreatorTokenContext = createContext<CreatorTokenContextType | undefined>(undefined)

export interface CreatorTokenProviderProps {
  token: string
  children: ReactNode
}

export const CreatorTokenProvider = ({ token, children }: CreatorTokenProviderProps) => {
  return <CreatorTokenContext.Provider value={{ token }}>{children}</CreatorTokenContext.Provider>
}

export const useCreatorToken = (): CreatorTokenContextType => {
  const context = useContext(CreatorTokenContext)
  if (context === undefined) {
    throw new Error('useCreatorToken must be used within a CreatorTokenProvider')
  }
  return context
}
